import './App.css';
import './styles.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Categories from './components/Categories';

function App() {
  return (
    <div className="App">
      <div className='container'>
      <Header></Header>
      <Categories></Categories>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
